// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/account/account.proto" (package "base.account", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { BoolValue } from "../../google/protobuf/wrappers";
import { Int64Value } from "../../google/protobuf/wrappers";
import { StringValue } from "../../google/protobuf/wrappers";
/**
 * @generated from protobuf message base.account.RefreshTokenResponse
 */
export interface RefreshTokenResponse {
    /**
     * @generated from protobuf field: string accessToken = 1
     */
    accessToken: string;
    /**
     * @generated from protobuf field: int64 expiresTimestamp = 2
     */
    expiresTimestamp: string;
    /**
     * @generated from protobuf field: string refreshToken = 3
     */
    refreshToken: string; // 刷新的token，有效期30天
    /**
     * @generated from protobuf field: int64 expiresIn = 4
     */
    expiresIn: string; // 在...时间（毫秒）内到期
}
/**
 * @generated from protobuf message base.account.RefreshTokenRequest
 */
export interface RefreshTokenRequest {
    /**
     * @generated from protobuf field: string refreshToken = 1
     */
    refreshToken: string;
}
/**
 * @generated from protobuf message base.account.ExistPasswordByClientResponse
 */
export interface ExistPasswordByClientResponse {
    /**
     * @generated from protobuf field: bool exist = 1
     */
    exist: boolean;
}
/**
 * @generated from protobuf message base.account.ExistPasswordByClientRequest
 */
export interface ExistPasswordByClientRequest {
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 1
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 2
     */
    accountId?: Int64Value;
}
/**
 * @generated from protobuf message base.account.CheckActivatedResponse
 */
export interface CheckActivatedResponse {
    /**
     * @generated from protobuf field: bool isActivated = 1
     */
    isActivated: boolean;
}
/**
 * @generated from protobuf message base.account.CheckActivatedRequest
 */
export interface CheckActivatedRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 1
     */
    accountId?: Int64Value;
}
/**
 * @generated from protobuf message base.account.ActivateAccountResponse
 */
export interface ActivateAccountResponse {
    /**
     * @generated from protobuf field: bool done = 1
     */
    done: boolean;
}
/**
 * @generated from protobuf message base.account.ActivateAccountRequest
 */
export interface ActivateAccountRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 1
     */
    accountId?: Int64Value;
}
/**
 * @generated from protobuf message base.account.CreateAccessTokenLinkRequest
 */
export interface CreateAccessTokenLinkRequest {
    /**
     * @generated from protobuf field: string parentAccessToken = 1
     */
    parentAccessToken: string;
    /**
     * @generated from protobuf field: int64 accountId = 2
     */
    accountId: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 3
     */
    client?: StringValue;
}
/**
 * @generated from protobuf message base.account.CreateAccessTokenLinkResponse
 */
export interface CreateAccessTokenLinkResponse {
    /**
     * @generated from protobuf field: string accessToken = 1
     */
    accessToken: string;
    /**
     * @generated from protobuf field: int64 expiresTimestamp = 2
     */
    expiresTimestamp: string;
    /**
     * @generated from protobuf field: bool activated = 3
     */
    activated: boolean;
    /**
     * @generated from protobuf field: int64 expiresIn = 4
     */
    expiresIn: string; // 在...时间（毫秒）内到期
}
/**
 * @generated from protobuf message base.account.ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: string password = 2
     */
    password: string;
}
/**
 * @generated from protobuf message base.account.ResetPasswordResponse
 */
export interface ResetPasswordResponse {
    /**
     * @generated from protobuf field: bool done = 1
     */
    done: boolean;
}
/**
 * @generated from protobuf message base.account.CreateRequest
 */
export interface CreateRequest {
    /**
     * @generated from protobuf field: google.protobuf.StringValue password = 1
     */
    password?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 2
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue activated = 3
     */
    activated?: BoolValue;
}
/**
 * @generated from protobuf message base.account.CreateResponse
 */
export interface CreateResponse {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: string accessToken = 2
     */
    accessToken: string;
    /**
     * @generated from protobuf field: int64 expiresTimestamp = 3
     */
    expiresTimestamp: string;
    /**
     * @generated from protobuf field: bool activated = 4
     */
    activated: boolean;
    /**
     * @generated from protobuf field: string refreshToken = 5
     */
    refreshToken: string; // 刷新的token，有效期30天
    /**
     * @generated from protobuf field: int64 expiresIn = 6
     */
    expiresIn: string; // 在...时间（毫秒）内到期
}
/**
 * @generated from protobuf message base.account.CreateAccessTokenRequest
 */
export interface CreateAccessTokenRequest {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 2
     */
    client?: StringValue;
}
/**
 * @generated from protobuf message base.account.CreateAccessTokenResponse
 */
export interface CreateAccessTokenResponse {
    /**
     * @generated from protobuf field: string accessToken = 1
     */
    accessToken: string;
    /**
     * @generated from protobuf field: int64 expiresTimestamp = 2
     */
    expiresTimestamp: string;
    /**
     * @generated from protobuf field: bool activated = 3
     */
    activated: boolean;
    /**
     * @generated from protobuf field: string refreshToken = 4
     */
    refreshToken: string; // 刷新的token，有效期30天
    /**
     * @generated from protobuf field: int64 expiresIn = 5
     */
    expiresIn: string; // 在...时间（毫秒）内到期
}
/**
 * @generated from protobuf message base.account.CreateAccessTokenByPasswordRequest
 */
export interface CreateAccessTokenByPasswordRequest {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: string password = 2
     */
    password: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 3
     */
    client?: StringValue;
}
/**
 * @generated from protobuf message base.account.CreateAccessTokenByPasswordResponse
 */
export interface CreateAccessTokenByPasswordResponse {
    /**
     * @generated from protobuf field: string accessToken = 1
     */
    accessToken: string;
    /**
     * @generated from protobuf field: bool activated = 2
     */
    activated: boolean;
    /**
     * @generated from protobuf field: int64 expiresTimestamp = 3
     */
    expiresTimestamp: string;
    /**
     * @generated from protobuf field: string refreshToken = 4
     */
    refreshToken: string; // 刷新的token，有效期30天
    /**
     * @generated from protobuf field: int64 expiresIn = 5
     */
    expiresIn: string; // 在...时间（毫秒）内到期
}
// message CreateAccessTokenByCaptchaRequest {
//    int64 accountId = 1;
// }
// 
// message CreateAccessTokenByCaptchaResponse {
//    string accessToken = 1;
// }

/**
 * @generated from protobuf message base.account.CheckAccessTokenRequest
 */
export interface CheckAccessTokenRequest {
    /**
     * @generated from protobuf field: string accessToken = 1
     */
    accessToken: string;
    /**
     * @generated from protobuf field: int64 accountId = 2
     */
    accountId: string;
}
/**
 * @generated from protobuf message base.account.CheckAccessTokenResponse
 */
export interface CheckAccessTokenResponse {
    /**
     * @generated from protobuf field: bool isValid = 1
     */
    isValid: boolean;
}
/**
 * @generated from protobuf message base.account.GetAccountContextTestRequest
 */
export interface GetAccountContextTestRequest {
    /**
     * @generated from protobuf field: string accessToken = 1
     */
    accessToken: string;
}
/**
 * @generated from protobuf message base.account.GetAccountContextRequest
 */
export interface GetAccountContextRequest {
    /**
     * @generated from protobuf field: string accessToken = 1
     */
    accessToken: string;
}
/**
 * @generated from protobuf message base.account.GetAccountContextTestResponse
 */
export interface GetAccountContextTestResponse {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: string nonce = 2
     */
    nonce: string;
    /**
     * @generated from protobuf field: int64 expiredTime = 3
     */
    expiredTime: string;
    /**
     * @generated from protobuf field: string signature = 100
     */
    signature: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 4
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: bool activated = 5
     */
    activated: boolean;
    /**
     * @generated from protobuf field: string refreshToken = 6
     */
    refreshToken: string; // 刷新的token，有效期30天
}
/**
 * 账号信息，作用类似于 JWT，服务可在本地自校验，减少访问 account service 的次数。
 *
 * @generated from protobuf message base.account.GetAccountContextResponse
 */
export interface GetAccountContextResponse {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: string nonce = 2
     */
    nonce: string;
    /**
     * @generated from protobuf field: int64 expiredTime = 3
     */
    expiredTime: string;
    /**
     * @generated from protobuf field: string signature = 100
     */
    signature: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 4
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: bool activated = 5
     */
    activated: boolean;
    /**
     * @generated from protobuf field: string refreshToken = 6
     */
    refreshToken: string; // 刷新的token，有效期30天
}
/**
 * @generated from protobuf message base.account.UpdatePasswordRequest
 */
export interface UpdatePasswordRequest {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * 旧密码
     *
     * @generated from protobuf field: string currentPassword = 2
     */
    currentPassword: string;
    /**
     * 新密码
     *
     * @generated from protobuf field: string newPassword = 3
     */
    newPassword: string;
}
/**
 * @generated from protobuf message base.account.UpdatePasswordResponse
 */
export interface UpdatePasswordResponse {
    /**
     * 是否更改
     *
     * @generated from protobuf field: bool isUpdated = 1
     */
    isUpdated: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class RefreshTokenResponse$Type extends MessageType<RefreshTokenResponse> {
    constructor() {
        super("base.account.RefreshTokenResponse", [
            { no: 1, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expiresTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "expiresIn", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<RefreshTokenResponse>): RefreshTokenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        message.expiresTimestamp = "0";
        message.refreshToken = "";
        message.expiresIn = "0";
        if (value !== undefined)
            reflectionMergePartial<RefreshTokenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefreshTokenResponse): RefreshTokenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string accessToken */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* int64 expiresTimestamp */ 2:
                    message.expiresTimestamp = reader.int64().toString();
                    break;
                case /* string refreshToken */ 3:
                    message.refreshToken = reader.string();
                    break;
                case /* int64 expiresIn */ 4:
                    message.expiresIn = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefreshTokenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string accessToken = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* int64 expiresTimestamp = 2; */
        if (message.expiresTimestamp !== "0")
            writer.tag(2, WireType.Varint).int64(message.expiresTimestamp);
        /* string refreshToken = 3; */
        if (message.refreshToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.refreshToken);
        /* int64 expiresIn = 4; */
        if (message.expiresIn !== "0")
            writer.tag(4, WireType.Varint).int64(message.expiresIn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.RefreshTokenResponse
 */
export const RefreshTokenResponse = new RefreshTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefreshTokenRequest$Type extends MessageType<RefreshTokenRequest> {
    constructor() {
        super("base.account.RefreshTokenRequest", [
            { no: 1, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RefreshTokenRequest>): RefreshTokenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.refreshToken = "";
        if (value !== undefined)
            reflectionMergePartial<RefreshTokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefreshTokenRequest): RefreshTokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string refreshToken */ 1:
                    message.refreshToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefreshTokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string refreshToken = 1; */
        if (message.refreshToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.refreshToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.RefreshTokenRequest
 */
export const RefreshTokenRequest = new RefreshTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExistPasswordByClientResponse$Type extends MessageType<ExistPasswordByClientResponse> {
    constructor() {
        super("base.account.ExistPasswordByClientResponse", [
            { no: 1, name: "exist", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ExistPasswordByClientResponse>): ExistPasswordByClientResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exist = false;
        if (value !== undefined)
            reflectionMergePartial<ExistPasswordByClientResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExistPasswordByClientResponse): ExistPasswordByClientResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool exist */ 1:
                    message.exist = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExistPasswordByClientResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool exist = 1; */
        if (message.exist !== false)
            writer.tag(1, WireType.Varint).bool(message.exist);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.ExistPasswordByClientResponse
 */
export const ExistPasswordByClientResponse = new ExistPasswordByClientResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExistPasswordByClientRequest$Type extends MessageType<ExistPasswordByClientRequest> {
    constructor() {
        super("base.account.ExistPasswordByClientRequest", [
            { no: 1, name: "client", kind: "message", T: () => StringValue },
            { no: 2, name: "accountId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<ExistPasswordByClientRequest>): ExistPasswordByClientRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExistPasswordByClientRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExistPasswordByClientRequest): ExistPasswordByClientRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue client */ 1:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* google.protobuf.Int64Value accountId */ 2:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExistPasswordByClientRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue client = 1; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value accountId = 2; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.ExistPasswordByClientRequest
 */
export const ExistPasswordByClientRequest = new ExistPasswordByClientRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckActivatedResponse$Type extends MessageType<CheckActivatedResponse> {
    constructor() {
        super("base.account.CheckActivatedResponse", [
            { no: 1, name: "isActivated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CheckActivatedResponse>): CheckActivatedResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isActivated = false;
        if (value !== undefined)
            reflectionMergePartial<CheckActivatedResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckActivatedResponse): CheckActivatedResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isActivated */ 1:
                    message.isActivated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckActivatedResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isActivated = 1; */
        if (message.isActivated !== false)
            writer.tag(1, WireType.Varint).bool(message.isActivated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CheckActivatedResponse
 */
export const CheckActivatedResponse = new CheckActivatedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckActivatedRequest$Type extends MessageType<CheckActivatedRequest> {
    constructor() {
        super("base.account.CheckActivatedRequest", [
            { no: 1, name: "accountId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<CheckActivatedRequest>): CheckActivatedRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CheckActivatedRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckActivatedRequest): CheckActivatedRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value accountId */ 1:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckActivatedRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value accountId = 1; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CheckActivatedRequest
 */
export const CheckActivatedRequest = new CheckActivatedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivateAccountResponse$Type extends MessageType<ActivateAccountResponse> {
    constructor() {
        super("base.account.ActivateAccountResponse", [
            { no: 1, name: "done", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ActivateAccountResponse>): ActivateAccountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.done = false;
        if (value !== undefined)
            reflectionMergePartial<ActivateAccountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActivateAccountResponse): ActivateAccountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool done */ 1:
                    message.done = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActivateAccountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool done = 1; */
        if (message.done !== false)
            writer.tag(1, WireType.Varint).bool(message.done);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.ActivateAccountResponse
 */
export const ActivateAccountResponse = new ActivateAccountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivateAccountRequest$Type extends MessageType<ActivateAccountRequest> {
    constructor() {
        super("base.account.ActivateAccountRequest", [
            { no: 1, name: "accountId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<ActivateAccountRequest>): ActivateAccountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ActivateAccountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActivateAccountRequest): ActivateAccountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value accountId */ 1:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActivateAccountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value accountId = 1; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.ActivateAccountRequest
 */
export const ActivateAccountRequest = new ActivateAccountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccessTokenLinkRequest$Type extends MessageType<CreateAccessTokenLinkRequest> {
    constructor() {
        super("base.account.CreateAccessTokenLinkRequest", [
            { no: 1, name: "parentAccessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "client", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<CreateAccessTokenLinkRequest>): CreateAccessTokenLinkRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.parentAccessToken = "";
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateAccessTokenLinkRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccessTokenLinkRequest): CreateAccessTokenLinkRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string parentAccessToken */ 1:
                    message.parentAccessToken = reader.string();
                    break;
                case /* int64 accountId */ 2:
                    message.accountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue client */ 3:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccessTokenLinkRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string parentAccessToken = 1; */
        if (message.parentAccessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.parentAccessToken);
        /* int64 accountId = 2; */
        if (message.accountId !== "0")
            writer.tag(2, WireType.Varint).int64(message.accountId);
        /* google.protobuf.StringValue client = 3; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CreateAccessTokenLinkRequest
 */
export const CreateAccessTokenLinkRequest = new CreateAccessTokenLinkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccessTokenLinkResponse$Type extends MessageType<CreateAccessTokenLinkResponse> {
    constructor() {
        super("base.account.CreateAccessTokenLinkResponse", [
            { no: 1, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expiresTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "activated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "expiresIn", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAccessTokenLinkResponse>): CreateAccessTokenLinkResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        message.expiresTimestamp = "0";
        message.activated = false;
        message.expiresIn = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateAccessTokenLinkResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccessTokenLinkResponse): CreateAccessTokenLinkResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string accessToken */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* int64 expiresTimestamp */ 2:
                    message.expiresTimestamp = reader.int64().toString();
                    break;
                case /* bool activated */ 3:
                    message.activated = reader.bool();
                    break;
                case /* int64 expiresIn */ 4:
                    message.expiresIn = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccessTokenLinkResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string accessToken = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* int64 expiresTimestamp = 2; */
        if (message.expiresTimestamp !== "0")
            writer.tag(2, WireType.Varint).int64(message.expiresTimestamp);
        /* bool activated = 3; */
        if (message.activated !== false)
            writer.tag(3, WireType.Varint).bool(message.activated);
        /* int64 expiresIn = 4; */
        if (message.expiresIn !== "0")
            writer.tag(4, WireType.Varint).int64(message.expiresIn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CreateAccessTokenLinkResponse
 */
export const CreateAccessTokenLinkResponse = new CreateAccessTokenLinkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetPasswordRequest$Type extends MessageType<ResetPasswordRequest> {
    constructor() {
        super("base.account.ResetPasswordRequest", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ResetPasswordRequest>): ResetPasswordRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.password = "";
        if (value !== undefined)
            reflectionMergePartial<ResetPasswordRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResetPasswordRequest): ResetPasswordRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* string password */ 2:
                    message.password = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResetPasswordRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* string password = 2; */
        if (message.password !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.password);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.ResetPasswordRequest
 */
export const ResetPasswordRequest = new ResetPasswordRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetPasswordResponse$Type extends MessageType<ResetPasswordResponse> {
    constructor() {
        super("base.account.ResetPasswordResponse", [
            { no: 1, name: "done", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ResetPasswordResponse>): ResetPasswordResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.done = false;
        if (value !== undefined)
            reflectionMergePartial<ResetPasswordResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResetPasswordResponse): ResetPasswordResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool done */ 1:
                    message.done = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResetPasswordResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool done = 1; */
        if (message.done !== false)
            writer.tag(1, WireType.Varint).bool(message.done);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.ResetPasswordResponse
 */
export const ResetPasswordResponse = new ResetPasswordResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRequest$Type extends MessageType<CreateRequest> {
    constructor() {
        super("base.account.CreateRequest", [
            { no: 1, name: "password", kind: "message", T: () => StringValue },
            { no: 2, name: "client", kind: "message", T: () => StringValue },
            { no: 3, name: "activated", kind: "message", T: () => BoolValue }
        ]);
    }
    create(value?: PartialMessage<CreateRequest>): CreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateRequest): CreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue password */ 1:
                    message.password = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.password);
                    break;
                case /* google.protobuf.StringValue client */ 2:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* google.protobuf.BoolValue activated */ 3:
                    message.activated = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.activated);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue password = 1; */
        if (message.password)
            StringValue.internalBinaryWrite(message.password, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue client = 2; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue activated = 3; */
        if (message.activated)
            BoolValue.internalBinaryWrite(message.activated, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CreateRequest
 */
export const CreateRequest = new CreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateResponse$Type extends MessageType<CreateResponse> {
    constructor() {
        super("base.account.CreateResponse", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expiresTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "activated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "expiresIn", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateResponse>): CreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.accessToken = "";
        message.expiresTimestamp = "0";
        message.activated = false;
        message.refreshToken = "";
        message.expiresIn = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateResponse): CreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* string accessToken */ 2:
                    message.accessToken = reader.string();
                    break;
                case /* int64 expiresTimestamp */ 3:
                    message.expiresTimestamp = reader.int64().toString();
                    break;
                case /* bool activated */ 4:
                    message.activated = reader.bool();
                    break;
                case /* string refreshToken */ 5:
                    message.refreshToken = reader.string();
                    break;
                case /* int64 expiresIn */ 6:
                    message.expiresIn = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* string accessToken = 2; */
        if (message.accessToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessToken);
        /* int64 expiresTimestamp = 3; */
        if (message.expiresTimestamp !== "0")
            writer.tag(3, WireType.Varint).int64(message.expiresTimestamp);
        /* bool activated = 4; */
        if (message.activated !== false)
            writer.tag(4, WireType.Varint).bool(message.activated);
        /* string refreshToken = 5; */
        if (message.refreshToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.refreshToken);
        /* int64 expiresIn = 6; */
        if (message.expiresIn !== "0")
            writer.tag(6, WireType.Varint).int64(message.expiresIn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CreateResponse
 */
export const CreateResponse = new CreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccessTokenRequest$Type extends MessageType<CreateAccessTokenRequest> {
    constructor() {
        super("base.account.CreateAccessTokenRequest", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "client", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<CreateAccessTokenRequest>): CreateAccessTokenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateAccessTokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccessTokenRequest): CreateAccessTokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue client */ 2:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccessTokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* google.protobuf.StringValue client = 2; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CreateAccessTokenRequest
 */
export const CreateAccessTokenRequest = new CreateAccessTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccessTokenResponse$Type extends MessageType<CreateAccessTokenResponse> {
    constructor() {
        super("base.account.CreateAccessTokenResponse", [
            { no: 1, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expiresTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "activated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "expiresIn", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAccessTokenResponse>): CreateAccessTokenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        message.expiresTimestamp = "0";
        message.activated = false;
        message.refreshToken = "";
        message.expiresIn = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateAccessTokenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccessTokenResponse): CreateAccessTokenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string accessToken */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* int64 expiresTimestamp */ 2:
                    message.expiresTimestamp = reader.int64().toString();
                    break;
                case /* bool activated */ 3:
                    message.activated = reader.bool();
                    break;
                case /* string refreshToken */ 4:
                    message.refreshToken = reader.string();
                    break;
                case /* int64 expiresIn */ 5:
                    message.expiresIn = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccessTokenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string accessToken = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* int64 expiresTimestamp = 2; */
        if (message.expiresTimestamp !== "0")
            writer.tag(2, WireType.Varint).int64(message.expiresTimestamp);
        /* bool activated = 3; */
        if (message.activated !== false)
            writer.tag(3, WireType.Varint).bool(message.activated);
        /* string refreshToken = 4; */
        if (message.refreshToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.refreshToken);
        /* int64 expiresIn = 5; */
        if (message.expiresIn !== "0")
            writer.tag(5, WireType.Varint).int64(message.expiresIn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CreateAccessTokenResponse
 */
export const CreateAccessTokenResponse = new CreateAccessTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccessTokenByPasswordRequest$Type extends MessageType<CreateAccessTokenByPasswordRequest> {
    constructor() {
        super("base.account.CreateAccessTokenByPasswordRequest", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<CreateAccessTokenByPasswordRequest>): CreateAccessTokenByPasswordRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.password = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAccessTokenByPasswordRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccessTokenByPasswordRequest): CreateAccessTokenByPasswordRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* string password */ 2:
                    message.password = reader.string();
                    break;
                case /* google.protobuf.StringValue client */ 3:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccessTokenByPasswordRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* string password = 2; */
        if (message.password !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.password);
        /* google.protobuf.StringValue client = 3; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CreateAccessTokenByPasswordRequest
 */
export const CreateAccessTokenByPasswordRequest = new CreateAccessTokenByPasswordRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccessTokenByPasswordResponse$Type extends MessageType<CreateAccessTokenByPasswordResponse> {
    constructor() {
        super("base.account.CreateAccessTokenByPasswordResponse", [
            { no: 1, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "activated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "expiresTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "expiresIn", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAccessTokenByPasswordResponse>): CreateAccessTokenByPasswordResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        message.activated = false;
        message.expiresTimestamp = "0";
        message.refreshToken = "";
        message.expiresIn = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateAccessTokenByPasswordResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccessTokenByPasswordResponse): CreateAccessTokenByPasswordResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string accessToken */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* bool activated */ 2:
                    message.activated = reader.bool();
                    break;
                case /* int64 expiresTimestamp */ 3:
                    message.expiresTimestamp = reader.int64().toString();
                    break;
                case /* string refreshToken */ 4:
                    message.refreshToken = reader.string();
                    break;
                case /* int64 expiresIn */ 5:
                    message.expiresIn = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccessTokenByPasswordResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string accessToken = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* bool activated = 2; */
        if (message.activated !== false)
            writer.tag(2, WireType.Varint).bool(message.activated);
        /* int64 expiresTimestamp = 3; */
        if (message.expiresTimestamp !== "0")
            writer.tag(3, WireType.Varint).int64(message.expiresTimestamp);
        /* string refreshToken = 4; */
        if (message.refreshToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.refreshToken);
        /* int64 expiresIn = 5; */
        if (message.expiresIn !== "0")
            writer.tag(5, WireType.Varint).int64(message.expiresIn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CreateAccessTokenByPasswordResponse
 */
export const CreateAccessTokenByPasswordResponse = new CreateAccessTokenByPasswordResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckAccessTokenRequest$Type extends MessageType<CheckAccessTokenRequest> {
    constructor() {
        super("base.account.CheckAccessTokenRequest", [
            { no: 1, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CheckAccessTokenRequest>): CheckAccessTokenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<CheckAccessTokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckAccessTokenRequest): CheckAccessTokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string accessToken */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* int64 accountId */ 2:
                    message.accountId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckAccessTokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string accessToken = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* int64 accountId = 2; */
        if (message.accountId !== "0")
            writer.tag(2, WireType.Varint).int64(message.accountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CheckAccessTokenRequest
 */
export const CheckAccessTokenRequest = new CheckAccessTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckAccessTokenResponse$Type extends MessageType<CheckAccessTokenResponse> {
    constructor() {
        super("base.account.CheckAccessTokenResponse", [
            { no: 1, name: "isValid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CheckAccessTokenResponse>): CheckAccessTokenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isValid = false;
        if (value !== undefined)
            reflectionMergePartial<CheckAccessTokenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckAccessTokenResponse): CheckAccessTokenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isValid */ 1:
                    message.isValid = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckAccessTokenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isValid = 1; */
        if (message.isValid !== false)
            writer.tag(1, WireType.Varint).bool(message.isValid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CheckAccessTokenResponse
 */
export const CheckAccessTokenResponse = new CheckAccessTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountContextTestRequest$Type extends MessageType<GetAccountContextTestRequest> {
    constructor() {
        super("base.account.GetAccountContextTestRequest", [
            { no: 1, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountContextTestRequest>): GetAccountContextTestRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        if (value !== undefined)
            reflectionMergePartial<GetAccountContextTestRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountContextTestRequest): GetAccountContextTestRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string accessToken */ 1:
                    message.accessToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountContextTestRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string accessToken = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetAccountContextTestRequest
 */
export const GetAccountContextTestRequest = new GetAccountContextTestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountContextRequest$Type extends MessageType<GetAccountContextRequest> {
    constructor() {
        super("base.account.GetAccountContextRequest", [
            { no: 1, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountContextRequest>): GetAccountContextRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        if (value !== undefined)
            reflectionMergePartial<GetAccountContextRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountContextRequest): GetAccountContextRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string accessToken */ 1:
                    message.accessToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountContextRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string accessToken = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetAccountContextRequest
 */
export const GetAccountContextRequest = new GetAccountContextRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountContextTestResponse$Type extends MessageType<GetAccountContextTestResponse> {
    constructor() {
        super("base.account.GetAccountContextTestResponse", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "nonce", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expiredTime", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 100, name: "signature", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "client", kind: "message", T: () => StringValue },
            { no: 5, name: "activated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountContextTestResponse>): GetAccountContextTestResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.nonce = "";
        message.expiredTime = "0";
        message.signature = "";
        message.activated = false;
        message.refreshToken = "";
        if (value !== undefined)
            reflectionMergePartial<GetAccountContextTestResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountContextTestResponse): GetAccountContextTestResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* string nonce */ 2:
                    message.nonce = reader.string();
                    break;
                case /* int64 expiredTime */ 3:
                    message.expiredTime = reader.int64().toString();
                    break;
                case /* string signature */ 100:
                    message.signature = reader.string();
                    break;
                case /* google.protobuf.StringValue client */ 4:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* bool activated */ 5:
                    message.activated = reader.bool();
                    break;
                case /* string refreshToken */ 6:
                    message.refreshToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountContextTestResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* string nonce = 2; */
        if (message.nonce !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nonce);
        /* int64 expiredTime = 3; */
        if (message.expiredTime !== "0")
            writer.tag(3, WireType.Varint).int64(message.expiredTime);
        /* google.protobuf.StringValue client = 4; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool activated = 5; */
        if (message.activated !== false)
            writer.tag(5, WireType.Varint).bool(message.activated);
        /* string refreshToken = 6; */
        if (message.refreshToken !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.refreshToken);
        /* string signature = 100; */
        if (message.signature !== "")
            writer.tag(100, WireType.LengthDelimited).string(message.signature);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetAccountContextTestResponse
 */
export const GetAccountContextTestResponse = new GetAccountContextTestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountContextResponse$Type extends MessageType<GetAccountContextResponse> {
    constructor() {
        super("base.account.GetAccountContextResponse", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "nonce", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expiredTime", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 100, name: "signature", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "client", kind: "message", T: () => StringValue },
            { no: 5, name: "activated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountContextResponse>): GetAccountContextResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.nonce = "";
        message.expiredTime = "0";
        message.signature = "";
        message.activated = false;
        message.refreshToken = "";
        if (value !== undefined)
            reflectionMergePartial<GetAccountContextResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountContextResponse): GetAccountContextResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* string nonce */ 2:
                    message.nonce = reader.string();
                    break;
                case /* int64 expiredTime */ 3:
                    message.expiredTime = reader.int64().toString();
                    break;
                case /* string signature */ 100:
                    message.signature = reader.string();
                    break;
                case /* google.protobuf.StringValue client */ 4:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* bool activated */ 5:
                    message.activated = reader.bool();
                    break;
                case /* string refreshToken */ 6:
                    message.refreshToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountContextResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* string nonce = 2; */
        if (message.nonce !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nonce);
        /* int64 expiredTime = 3; */
        if (message.expiredTime !== "0")
            writer.tag(3, WireType.Varint).int64(message.expiredTime);
        /* google.protobuf.StringValue client = 4; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool activated = 5; */
        if (message.activated !== false)
            writer.tag(5, WireType.Varint).bool(message.activated);
        /* string refreshToken = 6; */
        if (message.refreshToken !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.refreshToken);
        /* string signature = 100; */
        if (message.signature !== "")
            writer.tag(100, WireType.LengthDelimited).string(message.signature);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetAccountContextResponse
 */
export const GetAccountContextResponse = new GetAccountContextResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePasswordRequest$Type extends MessageType<UpdatePasswordRequest> {
    constructor() {
        super("base.account.UpdatePasswordRequest", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "currentPassword", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "newPassword", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdatePasswordRequest>): UpdatePasswordRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.currentPassword = "";
        message.newPassword = "";
        if (value !== undefined)
            reflectionMergePartial<UpdatePasswordRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdatePasswordRequest): UpdatePasswordRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* string currentPassword */ 2:
                    message.currentPassword = reader.string();
                    break;
                case /* string newPassword */ 3:
                    message.newPassword = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdatePasswordRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* string currentPassword = 2; */
        if (message.currentPassword !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.currentPassword);
        /* string newPassword = 3; */
        if (message.newPassword !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.newPassword);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.UpdatePasswordRequest
 */
export const UpdatePasswordRequest = new UpdatePasswordRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePasswordResponse$Type extends MessageType<UpdatePasswordResponse> {
    constructor() {
        super("base.account.UpdatePasswordResponse", [
            { no: 1, name: "isUpdated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdatePasswordResponse>): UpdatePasswordResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUpdated = false;
        if (value !== undefined)
            reflectionMergePartial<UpdatePasswordResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdatePasswordResponse): UpdatePasswordResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isUpdated */ 1:
                    message.isUpdated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdatePasswordResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isUpdated = 1; */
        if (message.isUpdated !== false)
            writer.tag(1, WireType.Varint).bool(message.isUpdated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.UpdatePasswordResponse
 */
export const UpdatePasswordResponse = new UpdatePasswordResponse$Type();
/**
 * @generated ServiceType for protobuf service base.account.AccountService
 */
export const AccountService = new ServiceType("base.account.AccountService", [
    { name: "Create", options: {}, I: CreateRequest, O: CreateResponse },
    { name: "CreateAccessToken", options: {}, I: CreateAccessTokenRequest, O: CreateAccessTokenResponse },
    { name: "CreateAccessTokenByPassword", options: {}, I: CreateAccessTokenByPasswordRequest, O: CreateAccessTokenByPasswordResponse },
    { name: "GetAccountContext", options: {}, I: GetAccountContextRequest, O: GetAccountContextResponse },
    { name: "RefreshToken", options: { "google.api.http": { post: "/base.account.AccountService/RefreshToken", body: "*" } }, I: RefreshTokenRequest, O: RefreshTokenResponse },
    { name: "GetAccountContextTest", options: { "google.api.http": { post: "/base.account.AccountService/GetAccountContextTest", body: "*" } }, I: GetAccountContextTestRequest, O: GetAccountContextTestResponse },
    { name: "UpdatePassword", options: {}, I: UpdatePasswordRequest, O: UpdatePasswordResponse },
    { name: "ResetPassword", options: {}, I: ResetPasswordRequest, O: ResetPasswordResponse },
    { name: "CreateAccessTokenLink", options: {}, I: CreateAccessTokenLinkRequest, O: CreateAccessTokenLinkResponse },
    { name: "ActivateAccount", options: {}, I: ActivateAccountRequest, O: ActivateAccountResponse },
    { name: "CheckActivated", options: {}, I: CheckActivatedRequest, O: CheckActivatedResponse },
    { name: "ExistPasswordByClient", options: {}, I: ExistPasswordByClientRequest, O: ExistPasswordByClientResponse }
]);
